import React, {useState, useEffect} from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import x from './images/x.svg';

const PopUp = (props) => {
  const [fadeType, setFadeType] = useState('null');
  const [preventWrapperClose] = useState(props.preventWrapperClose != undefined ? props.preventWrapperClose : false);

  useEffect(() => {
    let el = document.getElementsByTagName('body')[0];
    if (props.showPopUp) {
      el.classList.add('modal-open');
      setFadeType('in');
    } else {
      el.classList.remove('modal-open');
    }
    return () => {
      document.getElementsByTagName('body')[0].classList.remove('modal-open');
    };
  }, [props.showPopUp]);

  return props.showPopUp ? (
    <>
      <div className={`popup-overlay`} onClick={props.onClose} />
      <div
        className={`wrapper-popup ${props.className ? props.className : ''} ${props.isPopupFromBottomOnMobile ? 'popup-from-bottom' : ''}`}
        role='dialog'
        onClick={handleWrapperPopupClick}
        >
        <div className={`box-dialog fade-${fadeType}`} style={props.style}>
          <div className={props?.hideCloseButton ? 'box-header hidden' : 'box-header'}>
            <button onClick={props.onClose} className='close-btn' style={{backgroundImage:x.bg()}}></button>
          </div>
          <div className='box-content'>
            <div> {props.children} </div>

            {props.footerBtn && (
              <div className='popup-btn-wrapper'>
                <BtnSubmit text={props.footerBtn.text} onclick={props.footerBtn.onBtnClick} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : null;

  function handleWrapperPopupClick(e) {
    if (e.target.classList.contains('wrapper-popup')) {
      if (!preventWrapperClose) {
        props.onClose();
      }
    }
  }
};

export default PopUp;
